const interval = setInterval(() => {
  const titulo = document.querySelector(".jdgm-rev-widg__title");
  if (titulo) {
    titulo.textContent = window.translations.reviews_title;
    clearInterval(interval); // para de tentar após atualizar
  }
}, 10); // verifica a cada 10ms